"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFunction = isFunction;
exports.isStringInDomain = isStringInDomain;
exports.objectDoesExist = objectDoesExist;
exports.domainSuffix = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _enviro = _interopRequireDefault(require("enviro"));

function isFunction(func) {
  return typeof func === 'function';
}

function isStringInDomain(str) {
  return window.location.host.indexOf(str) !== -1;
}

function objectDoesExist() {
  var baseObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  var objectArray = arguments.length > 1 ? arguments[1] : undefined;
  var objectArrayLength = objectArray.length;
  var obj = baseObject[objectArray[0]]; // Object does not exist at this path

  if (typeof obj === 'undefined' || obj === null) {
    return false;
  } // Traverse the object path array until we hit the end


  if (objectArrayLength > 1 && (0, _typeof2.default)(obj) === 'object') {
    return objectDoesExist(obj, objectArray.slice(1, objectArrayLength));
  }

  return true;
}

var domainSuffix = function () {
  if (_enviro.default.getShort() === 'qa') {
    return 'qa';
  }

  return '';
}();

exports.domainSuffix = domainSuffix;